var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ValueRegionBoxAdapter_instances, _ValueRegionBoxAdapter_terminator, _ValueRegionBoxAdapter_context, _ValueRegionBoxAdapter_box, _ValueRegionBoxAdapter_changeNotifier, _ValueRegionBoxAdapter_isSelected, _ValueRegionBoxAdapter_isConstructing, _ValueRegionBoxAdapter_eventCollectionSubscription, _ValueRegionBoxAdapter_dispatchChange;
import { Interpolation, LoopableRegion, PPQN, RegionCollection } from "@opendaw/lib-dsp";
import { Arrays, Integer, isDefined, Notifier, Option, safeExecute, Terminable, Terminator, UUID } from "@opendaw/lib-std";
import { Propagation } from "@opendaw/lib-box";
import { TrackBoxAdapter } from "../TrackBoxAdapter";
import { ValueEventCollectionBoxAdapter } from "../collection/ValueEventCollectionBoxAdapter";
import { ValueEventBox, ValueEventCollectionBox, ValueRegionBox } from "@opendaw/studio-boxes";
import { InterpolationFieldAdapter } from "../event/InterpolationFieldAdapter";
export class ValueRegionBoxAdapter {
    constructor(context, box) {
        _ValueRegionBoxAdapter_instances.add(this);
        this.type = "value-region";
        _ValueRegionBoxAdapter_terminator.set(this, new Terminator());
        _ValueRegionBoxAdapter_context.set(this, void 0);
        _ValueRegionBoxAdapter_box.set(this, void 0);
        _ValueRegionBoxAdapter_changeNotifier.set(this, void 0);
        _ValueRegionBoxAdapter_isSelected.set(this, void 0);
        _ValueRegionBoxAdapter_isConstructing.set(this, void 0); // Prevents stack overflow due to infinite adapter queries
        _ValueRegionBoxAdapter_eventCollectionSubscription.set(this, Terminable.Empty);
        __classPrivateFieldSet(this, _ValueRegionBoxAdapter_context, context, "f");
        __classPrivateFieldSet(this, _ValueRegionBoxAdapter_box, box, "f");
        __classPrivateFieldSet(this, _ValueRegionBoxAdapter_isConstructing, true, "f");
        __classPrivateFieldSet(this, _ValueRegionBoxAdapter_changeNotifier, new Notifier(), "f");
        __classPrivateFieldSet(this, _ValueRegionBoxAdapter_isSelected, false, "f");
        __classPrivateFieldGet(this, _ValueRegionBoxAdapter_terminator, "f").own(__classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").pointerHub.subscribe({
            onAdded: () => __classPrivateFieldGet(this, _ValueRegionBoxAdapter_instances, "m", _ValueRegionBoxAdapter_dispatchChange).call(this),
            onRemoved: () => __classPrivateFieldGet(this, _ValueRegionBoxAdapter_instances, "m", _ValueRegionBoxAdapter_dispatchChange).call(this)
        }));
        __classPrivateFieldGet(this, _ValueRegionBoxAdapter_terminator, "f").own(__classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").subscribe(Propagation.Children, (update) => {
            if (this.trackBoxAdapter.isEmpty()) {
                return;
            }
            if (update.type === "primitive" || update.type === "pointer") {
                const track = this.trackBoxAdapter.unwrap();
                if (__classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").position.address.equals(update.address)) {
                    track.regions.onIndexingChanged();
                    __classPrivateFieldGet(this, _ValueRegionBoxAdapter_instances, "m", _ValueRegionBoxAdapter_dispatchChange).call(this);
                }
                else {
                    __classPrivateFieldGet(this, _ValueRegionBoxAdapter_instances, "m", _ValueRegionBoxAdapter_dispatchChange).call(this);
                }
            }
        }));
        __classPrivateFieldGet(this, _ValueRegionBoxAdapter_terminator, "f").own(__classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").events.catchupAndSubscribe(({ targetVertex }) => {
            __classPrivateFieldGet(this, _ValueRegionBoxAdapter_eventCollectionSubscription, "f").terminate();
            __classPrivateFieldSet(this, _ValueRegionBoxAdapter_eventCollectionSubscription, targetVertex.match({
                none: () => Terminable.Empty,
                some: ({ box }) => __classPrivateFieldGet(this, _ValueRegionBoxAdapter_context, "f").boxAdapters
                    .adapterFor(box, ValueEventCollectionBoxAdapter)
                    .subscribeChange(() => __classPrivateFieldGet(this, _ValueRegionBoxAdapter_instances, "m", _ValueRegionBoxAdapter_dispatchChange).call(this))
            }), "f");
            __classPrivateFieldGet(this, _ValueRegionBoxAdapter_instances, "m", _ValueRegionBoxAdapter_dispatchChange).call(this);
        }));
        __classPrivateFieldSet(this, _ValueRegionBoxAdapter_isConstructing, false, "f");
    }
    valueAt(position, fallback) {
        const content = this.optCollection;
        return content.isEmpty() ? fallback : content.unwrap().valueAt(LoopableRegion.globalToLocal(this, position), fallback);
    }
    incomingValue(fallback) {
        const content = this.optCollection;
        if (content.isEmpty()) {
            return fallback;
        }
        const zeroEvent = content.unwrap().events.greaterEqual(0);
        if (isDefined(zeroEvent) && zeroEvent.position === 0) {
            return zeroEvent.value;
        }
        return this.valueAt(this.position, fallback);
    }
    outgoingValue(fallback) {
        const optContent = this.optCollection;
        if (optContent.isEmpty()) {
            return fallback;
        }
        const content = optContent.unwrap();
        const endsOnLoopPass = (this.complete - this.offset) % this.loopDuration === 0;
        return endsOnLoopPass
            ? content.valueAt(this.loopDuration, fallback)
            : content.valueAt(LoopableRegion.globalToLocal(this, this.complete), fallback);
    }
    subscribeChange(observer) { return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_changeNotifier, "f").subscribe(observer); }
    accept(visitor) {
        return safeExecute(visitor.visitValueRegionBoxAdapter, this);
    }
    onSelected() {
        __classPrivateFieldSet(this, _ValueRegionBoxAdapter_isSelected, true, "f");
        __classPrivateFieldGet(this, _ValueRegionBoxAdapter_instances, "m", _ValueRegionBoxAdapter_dispatchChange).call(this);
    }
    onDeselected() {
        __classPrivateFieldSet(this, _ValueRegionBoxAdapter_isSelected, false, "f");
        __classPrivateFieldGet(this, _ValueRegionBoxAdapter_instances, "m", _ValueRegionBoxAdapter_dispatchChange).call(this);
    }
    get isSelected() { return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_isSelected, "f"); }
    onValuesPropertyChanged() { __classPrivateFieldGet(this, _ValueRegionBoxAdapter_instances, "m", _ValueRegionBoxAdapter_dispatchChange).call(this); }
    onValuesSortingChanged() { this.onValuesPropertyChanged(); }
    terminate() {
        __classPrivateFieldGet(this, _ValueRegionBoxAdapter_eventCollectionSubscription, "f").terminate();
        __classPrivateFieldGet(this, _ValueRegionBoxAdapter_terminator, "f").terminate();
    }
    get box() { return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f"); }
    get uuid() { return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").address.uuid; }
    get address() { return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").address; }
    get position() { return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").position.getValue(); }
    get duration() { return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").duration.getValue(); }
    get loopOffset() { return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").loopOffset.getValue(); }
    get loopDuration() { return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").loopDuration.getValue(); }
    get offset() { return this.position - this.loopOffset; }
    get complete() { return this.position + this.duration; }
    isNoteRegion() { return false; }
    isAudioRegion() { return false; }
    isValueRegion() { return true; }
    resolveDuration(_position) { return this.duration; }
    resolveComplete(position) { return position + this.duration; }
    resolveLoopDuration(_position) { return this.loopDuration; }
    get mute() { return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").mute.getValue(); }
    get hue() { return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").hue.getValue(); }
    get hasCollection() { return !this.optCollection.isEmpty(); }
    get events() {
        return this.optCollection.map(collection => collection.events);
    }
    get optCollection() {
        return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").events.targetVertex
            .map(vertex => __classPrivateFieldGet(this, _ValueRegionBoxAdapter_context, "f").boxAdapters.adapterFor(vertex.box, ValueEventCollectionBoxAdapter));
    }
    get label() { return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").label.getValue(); }
    get trackBoxAdapter() {
        if (__classPrivateFieldGet(this, _ValueRegionBoxAdapter_isConstructing, "f")) {
            return Option.None;
        }
        return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").regions.targetVertex
            .map(vertex => __classPrivateFieldGet(this, _ValueRegionBoxAdapter_context, "f").boxAdapters.adapterFor(vertex.box, TrackBoxAdapter));
    }
    get isMirrowed() { return this.optCollection.mapOr(adapter => adapter.numOwners > 1, false); }
    get canMirror() { return true; }
    get canResize() { return true; }
    set position(value) { __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").position.setValue(value); }
    set duration(value) { __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").duration.setValue(value); }
    set loopOffset(value) { __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").loopOffset.setValue(value); }
    set loopDuration(value) { __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").loopDuration.setValue(value); }
    moveContentStart(delta) {
        if (delta === 0) {
            return;
        }
        this.consolidate();
        this.optCollection.ifSome(collection => collection.events.asArray().slice()
            .forEach(event => event.box.position.setValue(event.position - delta)));
        this.position = this.position + delta;
        this.loopDuration = this.loopDuration - delta;
        this.duration = this.duration - delta;
    }
    copyTo(params) {
        const eventCollection = this.optCollection.unwrap("Cannot make copy without event-collection");
        const eventTarget = params?.consolidate === true
            ? eventCollection.copy().box.owners
            : eventCollection.box.owners;
        return __classPrivateFieldGet(this, _ValueRegionBoxAdapter_context, "f").boxAdapters.adapterFor(ValueRegionBox.create(__classPrivateFieldGet(this, _ValueRegionBoxAdapter_context, "f").boxGraph, UUID.generate(), box => {
            box.position.setValue(params?.position ?? this.position);
            box.duration.setValue(params?.duration ?? this.duration);
            box.loopOffset.setValue(params?.loopOffset ?? this.loopOffset);
            box.loopDuration.setValue(params?.loopDuration ?? this.loopDuration);
            box.hue.setValue(this.hue);
            box.label.setValue(this.label);
            box.mute.setValue(this.mute);
            box.events.refer(eventTarget);
            box.regions.refer(params?.target ?? __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").regions.targetVertex.unwrap("regions.target"));
        }), ValueRegionBoxAdapter);
    }
    consolidate() {
        if (!this.isMirrowed) {
            return;
        }
        this.events.ifSome(events => {
            const graph = __classPrivateFieldGet(this, _ValueRegionBoxAdapter_context, "f").boxGraph;
            const collectionBox = ValueEventCollectionBox.create(graph, UUID.generate());
            events.asArray().forEach(adapter => adapter.copyTo({ events: collectionBox.events }));
            __classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").events.refer(collectionBox.owners);
        });
    }
    canFlatten(regions) {
        return regions.length > 0
            && Arrays.satisfy(regions, (a, b) => a.trackBoxAdapter.contains(b.trackBoxAdapter.unwrap("trackBoxAdapter")))
            && regions.every(region => region.isSelected && region instanceof ValueRegionBoxAdapter);
    }
    flatten(regions) {
        if (!this.canFlatten(regions)) {
            return Option.None;
        }
        const graph = __classPrivateFieldGet(this, _ValueRegionBoxAdapter_context, "f").boxGraph;
        const sorted = regions.toSorted(RegionCollection.Comparator);
        const first = Arrays.getFirst(sorted, "Internal error (no first)");
        const last = Arrays.getLast(sorted, "Internal error (no last)");
        const rangeMin = first.position;
        const rangeMax = last.position + last.duration;
        const trackBoxAdapter = first.trackBoxAdapter.unwrap("trackBoxAdapter");
        const overlapping = Array.from(trackBoxAdapter.regions.collection.iterateRange(rangeMin, rangeMax));
        const entries = [];
        overlapping
            .filter(region => region.isSelected)
            .forEach(anyRegion => {
            const region = anyRegion;
            const collection = region.optCollection.unwrap("optCollection");
            const events = collection.events;
            for (const { rawStart, regionStart, regionEnd } of LoopableRegion.locateLoops(region, region.position, region.complete)) {
                const searchMin = regionStart - rawStart;
                const searchMax = regionEnd - rawStart;
                const firstContent = events.greaterEqual(searchMin);
                if (!isDefined(firstContent) || firstContent.position !== searchMin) {
                    const lowerEvent = events.lowerEqual(searchMin);
                    if (isDefined(lowerEvent)) {
                        entries.push({
                            position: regionStart - rangeMin,
                            value: collection.valueAt(searchMin, 0),
                            interpolation: lowerEvent.interpolation
                        });
                    }
                }
                let addedBoundary = false;
                for (const event of events.iterateRange(searchMin, Integer.MAX_VALUE)) {
                    const globalPos = event.position + rawStart;
                    if (globalPos < regionEnd) {
                        entries.push({
                            position: globalPos - rangeMin,
                            value: event.value,
                            interpolation: event.interpolation
                        });
                    }
                    else if (globalPos === regionEnd) {
                        entries.push({
                            position: globalPos - rangeMin,
                            value: event.value,
                            interpolation: Interpolation.None
                        });
                        addedBoundary = true;
                        break;
                    }
                    else {
                        entries.push({
                            position: regionEnd - rangeMin,
                            value: collection.valueAt(searchMax, 0),
                            interpolation: Interpolation.None
                        });
                        addedBoundary = true;
                        break;
                    }
                }
                if (!addedBoundary) {
                    entries.push({
                        position: regionEnd - rangeMin,
                        value: collection.valueAt(searchMax, 0),
                        interpolation: Interpolation.None
                    });
                }
            }
        });
        const cleaned = [];
        for (const entry of entries) {
            const prev = cleaned.length > 0 ? cleaned[cleaned.length - 1] : undefined;
            if (isDefined(prev) && prev.position === entry.position && prev.value === entry.value) {
                cleaned[cleaned.length - 1] = entry;
            }
            else {
                cleaned.push(entry);
            }
        }
        const collectionBox = ValueEventCollectionBox.create(graph, UUID.generate());
        let idx = 0;
        while (idx < cleaned.length) {
            let end = idx + 1;
            while (end < cleaned.length && cleaned[end].position === cleaned[idx].position) {
                end++;
            }
            const firstEntry = cleaned[idx];
            const lastEntry = cleaned[end - 1];
            const eventBox = ValueEventBox.create(graph, UUID.generate(), box => {
                box.position.setValue(firstEntry.position);
                box.index.setValue(0);
                box.value.setValue(firstEntry.value);
                box.events.refer(collectionBox.events);
            });
            InterpolationFieldAdapter.write(eventBox.interpolation, end - idx > 1 ? Interpolation.None : firstEntry.interpolation);
            if (end - idx > 1) {
                const lastBox = ValueEventBox.create(graph, UUID.generate(), box => {
                    box.position.setValue(lastEntry.position);
                    box.index.setValue(1);
                    box.value.setValue(lastEntry.value);
                    box.events.refer(collectionBox.events);
                });
                InterpolationFieldAdapter.write(lastBox.interpolation, lastEntry.interpolation);
            }
            idx = end;
        }
        overlapping.forEach(({ box }) => box.delete());
        return Option.wrap(ValueRegionBox.create(graph, UUID.generate(), box => {
            box.position.setValue(rangeMin);
            box.duration.setValue(rangeMax - rangeMin);
            box.loopDuration.setValue(rangeMax - rangeMin);
            box.loopOffset.setValue(0);
            box.hue.setValue(this.hue);
            box.mute.setValue(this.mute);
            box.label.setValue(this.label);
            box.events.refer(collectionBox.owners);
            box.regions.refer(trackBoxAdapter.box.regions);
        }));
    }
    toString() { return `{ValueRegionBoxAdapter ${UUID.toString(__classPrivateFieldGet(this, _ValueRegionBoxAdapter_box, "f").address.uuid)} p: ${PPQN.toString(this.position)}, c: ${PPQN.toString(this.complete)}}`; }
}
_ValueRegionBoxAdapter_terminator = new WeakMap(), _ValueRegionBoxAdapter_context = new WeakMap(), _ValueRegionBoxAdapter_box = new WeakMap(), _ValueRegionBoxAdapter_changeNotifier = new WeakMap(), _ValueRegionBoxAdapter_isSelected = new WeakMap(), _ValueRegionBoxAdapter_isConstructing = new WeakMap(), _ValueRegionBoxAdapter_eventCollectionSubscription = new WeakMap(), _ValueRegionBoxAdapter_instances = new WeakSet(), _ValueRegionBoxAdapter_dispatchChange = function _ValueRegionBoxAdapter_dispatchChange() {
    __classPrivateFieldGet(this, _ValueRegionBoxAdapter_changeNotifier, "f").notify();
    this.trackBoxAdapter.unwrapOrNull()?.regions?.dispatchChange();
};
